import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  forwardRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-checkbox',
  template: `
    <label class="cursor-pointer">
      <input
        type="checkbox"
        [checked]="checked"
        [ngModel]="checked"
        [disabled]="disabled"
        class="hidden"
        (ngModelChange)="innerCheckedChange($event)" />
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <rect
          x="0.5"
          y="0.5"
          width="19"
          height="19"
          rx="3.5"
          [ngClass]="{
            'fill-neutral-50': !disabled && !checked,
            'stroke-neutral-300': !disabled && !checked,
            'fill-primary-600': !disabled && checked,
            'fill-neutral-300': disabled && !checked,
            'stroke-neutral-500': disabled && !checked,
            'fill-neutral-500': disabled && checked,
            'stroke-none': checked,
            'duration-200': true
          }"
          fill="#F7F9F8"
          stroke="#D7D9D8" />
        <path
          *ngIf="checked"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.8047 5.86189C16.0651 6.12224 16.0651 6.54435 15.8047 6.8047L8.4714 14.138C8.21106 14.3984 7.78894 14.3984 7.5286 14.138L4.19526 10.8047C3.93491 10.54435 3.93491 10.12224 4.19526 9.86189C4.45561 9.60154 4.87772 9.60154 5.13807 9.86189L8 12.7238L14.8619 5.86189C15.1223 5.60154 15.5444 5.60154 15.8047 5.86189Z"
          fill="white"
          class="duration-200" />
      </svg>
      <span class="prose prose-text-sm ml-3"><ng-content></ng-content></span>
    </label>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ]
})
export class CheckboxComponent implements ControlValueAccessor, OnDestroy {
  onChange: Function = (value: boolean) => {};
  onTouched: Function = () => {};

  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(obj: any): void {
    this.checked = obj;
    this.cdr.markForCheck();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = this.disabled || isDisabled;
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  innerCheckedChange(checked: boolean) {
    if (!this.disabled) {
      this.checked = checked;
      this.onChange(this.checked);
    }
  }
}
